<template>
	<Container>
		<Title>
			{{ $t('user_profile') }}
		</Title>
		<div class="flex" :class="[adminMenu ? 'flex-row' : 'flex-col']">
			<MenuProfile class="w-1/5 max-width" />
			<transition name="fade">
				<router-view class="w-full" />
			</transition>
		</div>
	</Container>
</template>

<script>
import MenuProfile from '@/components/MenuProfile.vue'
import { mapGetters } from 'vuex'

export default {
	components: {
		MenuProfile
	},
	computed: {
		...mapGetters({
			adminMenu: 'adminMenu'
		})
	}
}
</script>
<style scoped>
.max-width {
	max-width: 20%;
}
</style>
